import { TDefaultChartTimeSpan } from "../../../features/settings/settings.types";
import { ToggleOption } from "../../TogglePillGroup";

export const BASIC_FILTERS: ToggleOption<number>[] = [
  { value: 1, label: "Dy", tooltip: "Show 1 Day" },
  { value: 7, label: "Wk", tooltip: "Show 1 Week" },
  { value: 30, label: "Mo", tooltip: "Show 1 Month" },
  { value: 90, label: "3 Mo", tooltip: "Show 3 Months" },
  { value: 365, label: "Yr", tooltip: "Show 1 Year" },
];

export const createFilters = (
  _chartsTimeSpan: TDefaultChartTimeSpan,
): ToggleOption<number>[] => {
  // Always show all 5 buttons on the historical chart
  return BASIC_FILTERS;
};

export const getDefaultFilterValue = (
  chartsTimeSpan: TDefaultChartTimeSpan,
): number => {
  switch (chartsTimeSpan) {
    case "OneDay":
      return 1;
    case "OneWeek":
      return 7;
    case "OneMonth":
      return 30;
    case "ThreeMonths":
      return 90;
    case "OneYear":
    default:
      return 365;
  }
};
